import { Outlet } from 'react-router-dom';
import useOrganizations from '../useOrganizations';
import { Organization } from '@/types';

export interface OrganizationContext {
  organizations: Record<Organization['id'], Organization>;
  currentOrganization: Organization;
}

const OrganizationLayout = () => {
  const { organizations, currentOrganization } = useOrganizations();

  return (
    <Outlet context={{ currentOrganization, organizations }} />
  );
};

export default OrganizationLayout;
